export default __webpack_public_path__ + "static/media/csv.12132442.svg";